import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PortalApiService } from '../../portal-api.service';
import { PortalAuthService } from '../../portal-auth.service';

@Component({
	selector: 'portal-document',
	templateUrl: './document.component.html',
	styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {

	loading = true;
	error = '';
	frameLoading = true;
	src: SafeResourceUrl | null = null;

	// Where the back link goes — the section this quote belongs to.
	backLink: any[] = ['/'];

	constructor(
		private route: ActivatedRoute,
		private api: PortalApiService,
		private auth: PortalAuthService,
		private sanitizer: DomSanitizer
	) {}

	ngOnInit(): void {
		const quoteId = this.route.snapshot.paramMap.get('quoteId') || '';
		const target = this.route.snapshot.queryParamMap.get('target') || 'proposal';
		const mode = this.route.snapshot.queryParamMap.get('mode') || 'view';
		this.api.quote.document(quoteId, target, mode, (res: any) => {
			this.loading = false;
			if (!res?.url) { this.error = 'This document is no longer available.'; return; }
			this.src = this.sanitizer.bypassSecurityTrustResourceUrl(res.url);
		}, (err: any) => {
			this.loading = false;
			if (err?.status === 401) { this.auth.goToLogin(); return; }
			this.error = err?.message || 'Could not open this document.';
		});
	}
}
